import { h, Fragment } from "preact";
import { Info } from "../../helpers/icons";

export default function StockStatusTooltip({ tooltip }) {
  return (
    <info-tooltip class="info-tooltip">
      <details class="info-tooltip__details">
        <summary class="info-tooltip__summary">
          <Info />
          <span class="visually-hidden">More info</span>
        </summary>
        <div
          className="rte--simple"
          data-content
          dangerouslySetInnerHTML={{
            __html: tooltip,
          }}
        ></div>
      </details>
    </info-tooltip>
  );
}
